import dayjs from "dayjs";

/**
 * A function that is used to ensure that the arrivalDate that will be sent to the backend is at minimum the current time + the booking allow time duration
 *
 * @param {dayjs.Dayjs} arrivalTime
 * @param {number} bookingAllowedTime
 * @param {dayjs.Dayjs} arrivalDate
 * @returns {string}
 */
export const getArrivalTime = (
  arrivalTime,
  bookingAllowedTime,
  arrivalDate
) => {
  const minAllowedTime = dayjs().add(bookingAllowedTime, "hours");
  if (
    arrivalTime.isBefore(minAllowedTime, "minutes") &&
    !arrivalDate?.isAfter(dayjs().add(bookingAllowedTime, "hours"), "day")
  ) {
    return minAllowedTime.format("HH:mm");
  }
  return arrivalTime.format("HH:mm");
};
